export default __webpack_public_path__ + "static/media/feedback.9586b16a.svg";